import { configureStore } from '@reduxjs/toolkit';
import customizationReducer from 'store/customization/customizationSlice';
import guestReducer from 'store/user/guest/guestSlice';
import userReducer from 'store/user/userSlice';
import userSessionsReducer from 'store/user/sessions/userSessionsSlice';
import sessionsReducer from 'store/sessions/sessionsSlice';
import sessionLookupReducer from 'store/sessionLookup/sessionLookupSlice';
import categoriesReducer from 'store/categories/categoriesSlice';
import audienceReducer from 'store/audience/audienceSlice';
import employeesReducer from 'store/employees/employeesSlice';
import eventRegistrationReducer from 'store/sessionRegistration/sessionRegistrationSlice';
import demographicsReducer from 'store/demographics/demographicsSlice';
import libraryReducer from 'store/library/librarySlice';
import assessmentsReducer from 'store/assessments/assessmentsSlice';

export const store = configureStore({
	reducer: {
		customization: customizationReducer,
		guest: guestReducer,
		user: userReducer,
		userSessions: userSessionsReducer,
		events: sessionsReducer,
		audience: audienceReducer,
		sessionLookup: sessionLookupReducer,
		categories: categoriesReducer,
		employees: employeesReducer,
		eventRegistration: eventRegistrationReducer,
		demographics: demographicsReducer,
		library: libraryReducer,
		assessments:assessmentsReducer
	}
});
